// removed by extract-text-webpack-plugin
module.exports = {"colorPalette":"CwColorPalette-colorPalette","swatch":"CwColorPalette-swatch"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwcolorfield/CwColorPalette.scss
// module id = 356
// module chunks = 0